import { generalStates } from '../reducers/generalReducer'
import { formStates } from '../reducers/formReducer'
import { authStates } from '../reducers/authReducer'
import { registrationStates } from '../reducers/registrationReducer'
import { paymentStates } from '../reducers/paymentReducer'

export const initialState = {
  generalStates,
  formStates,
  authStates,
  registrationStates,
  paymentStates
};